import { CustomerLeadCardProps } from './types/propTypes';
import styles from './CustomerLeadCard.module.scss';

const CustomerLeadCard = (props: CustomerLeadCardProps) => {
  const tagBackgroundColor = `customer-card-tag-bg-color-${props.tagBackgroundColor || 'white'}`;
  const tagNameColor = `customer-card-tag-name-color-${props.tagNameColor}`;

  return (
    <div className={`${styles['customer-lead-card-container']}`} data-testid="customer-lead-card-container-testid">
      <div className={`${styles['customer-lead-card-wrapper']}`}>
        {props.tagName && (
          <div
            className={`${styles['customer-lead-card-tag-container']} ${styles[tagBackgroundColor]} ${styles[tagNameColor]}`}
            data-testid="customer-lead-card-tag-testid"
          >
            {props.tagName}
          </div>
        )}
        <div className={`${styles['customer-lead-card-title']}`} data-testid="customer-lead-card-title-testid">
          {props.title}
        </div>
        <div className={`${styles['customer-lead-card-subtitle']}`} data-testid="customer-lead-card-subtitle-testid">
          {props.description && <>{props.description}</>}
        </div>
      </div>
    </div>
  );
};

export default CustomerLeadCard;
